<script setup>
import { ref, computed } from 'vue'
import { noImage } from '@/common/helper'
import { useCatalogState } from '../composables/CatalogState'

const {
  relatedStockCurrent,
  isLocationView,
  isLoadingLocation,
  showCabinetMap,
  resolveImageUrl,
} = useCatalogState();
</script>

<template>
  <div class="w-full dark:text-white" style="min-height: 250px; max-height: 1000px;">
    <div v-if="isLoadingLocation" class="grid place-items-center w-full" style="height: 250px;">
      <Spinner size="12" />
    </div>
    <div class="flex flex-col justify-between" style="min-height: 250px;" v-else>
      <!-- Location name -->
      <h3 class="font-bold" v-if="relatedStockCurrent.location">{{ relatedStockCurrent.location.name }}</h3>
      <div class="dummy-placeholder" v-else></div>

      <!-- Location picture -->
      <div class="relative grid grid-cols-1 gap-4 w-full mt-2 mb-2">
        <!-- Show cabinet location/map -->
        <div class="w-full relative mt-2 overflow-hidden" v-if="relatedStockCurrent.location && isMapView">
          <div class="w-full relative">
            <img :src="relatedStockCurrent.location.imageBase64" :alt="relatedStockCurrent.location.name" class="w-full h-auto" />
            <div v-if="relatedStockCurrent.location.point"
                class="absolute z-10 pointer-events-none w-10 h-auto aspect-square rounded-full" :style="{
                  left: `${relatedStockCurrent.location.point.x}%`,
                  top: `${relatedStockCurrent.location.point.y}%`
                }"><i class="fa fa-map-marker-alt text-blue-500 text-2xl relative" style="left: -8px; top: -24px"></i>
            </div>
          </div>
          <!-- Clickable thumbnail picture -->
          <!-- <div class="w-full absolute right-0 bottom-0 overflow-hidden max-w-[150px] max-h-[150px] bg-white border border-1 border-gray-300 rounded-md" v-if="relatedStockCurrent.cabinet?.image?.id" @click="showCabinetPicture()">
            <div class="p-2">
              <img :src="resolveImageUrl(relatedStockCurrent.cabinet.image.smallImagePath)" alt="" class="w-full h-auto" />
            </div>
          </div> -->
          <!-- Full width picture -->
          <div class="w-full overflow-hidden max-w-full max-h-[450px] bg-white" v-if="relatedStockCurrent.cabinet?.image?.id">
            <img :src="resolveImageUrl(relatedStockCurrent.cabinet.image.mediumImagePath)" alt="" class="w-full h-auto" />
          </div>
        </div>
        <!-- Show cabinet picture -->
        <div class="w-full relative mt-2" v-else-if="relatedStockCurrent.location && !isMapView">
          <img :src="resolveImageUrl(relatedStockCurrent.cabinet.image.mediumImagePath)" alt="" class="w-full h-auto" />
          <div class="absolute right-0 -top-12 overflow-hidden" v-if="relatedStockCurrent.cabinet?.image">
            <Button type="secondary" @click="showCabinetMap()">
              <i class="fa fa-map-marker-alt text-blue-500 text-xl"></i>
            </Button>
          </div>
        </div>
        <!-- Show picture because map is missing -->
        <div class="w-full relative mt-2 overflow-hidden max-h-[980px]" v-else-if="relatedStockCurrent.cabinet?.image?.id">
          <img :src="resolveImageUrl(relatedStockCurrent.cabinet.image.mediumImagePath)" alt="" class="w-full h-auto" />
        </div>
        <!-- Missing map or picture -->
        <div class="text-center w-full" v-else>
          Izbrana omara nima naložene slike.
        </div>
      </div>

      <!-- Cabinet name and navigation buttons -->
      <!-- <div class="flex flex-row justify-between gap-2 w-full">
        <div class="grid place-items-center">
          <h3><span class="font-bold">{{ relatedStockCurrent.cabinet.name }}</span><span class="font-normal"> - zaloga {{ relatedStockCurrent.quantity }} kos</span></h3>
        </div>
        <div class="flex flex-row gap-2" v-if="relatedStockCount > 1">
          <Button type="primary" @click="prevRelatedStock()" :enabled="relatedStockIndex - 1 >= 0"><i class="fa fa-chevron-left"></i></Button>
          <Button type="primary" @click="nextRelatedStock()" :enabled="relatedStockIndex + 1 < relatedStockCount"><i class="fa fa-chevron-right"></i></Button>
        </div>
      </div> -->
      <div class="dummy-placeholder"></div>

    </div>
  </div>
</template>